import { AddressFormKey } from '@domgen/shared/enums/addressFormKey';

export enum FormKey {
  SUPER_CATEGORY = 'superCategory',
  ITEM_CATEGORY = 'itemCategory',
  MODEL_NUMBER = 'modelNumber',
  SERIAL_NUMBER = 'serialNumber',
  PURCHASE_PRICE = 'purchasePrice',
  ARRIVAL_DATE = 'purchaseDate',
  FIRST_NAME = 'firstName',
  LAST_NAME = 'lastName',
  EMAIL = 'email',
  PHONE_NUMBER = 'phoneNumber',
  ADDRESS_ID = AddressFormKey.ADDRESS_ID,
  ADDRESS = AddressFormKey.ADDRESS,
  ADDRESS_LINE_1 = AddressFormKey.ADDRESS_LINE_1,
  SUB_BUILDING = AddressFormKey.SUB_BUILDING,
  STREET_NUMBER = AddressFormKey.STREET_NUMBER,
  STREET = AddressFormKey.STREET,
  PO_BOX = AddressFormKey.PO_BOX,
  CITY = AddressFormKey.CITY,
  STATE_CODE = AddressFormKey.STATE_CODE,
  POSTAL_CODE = AddressFormKey.POSTAL_CODE,
  IS_VALID = AddressFormKey.IS_VALID,
  MERCHANDISE_ADDRESS_ID = AddressFormKey.MERCHANDISE_ADDRESS_ID,
  MERCHANDISE_ADDRESS = AddressFormKey.MERCHANDISE_ADDRESS,
  MERCHANDISE_ADDRESS_LINE_1 = AddressFormKey.MERCHANDISE_ADDRESS_LINE_1,
  MERCHANDISE_SUB_BUILDING = AddressFormKey.MERCHANDISE_SUB_BUILDING,
  MERCHANDISE_STREET_NUMBER = AddressFormKey.MERCHANDISE_STREET_NUMBER,
  MERCHANDISE_STREET = AddressFormKey.MERCHANDISE_STREET,
  MERCHANDISE_PO_BOX = AddressFormKey.MERCHANDISE_PO_BOX,
  MERCHANDISE_CITY = AddressFormKey.MERCHANDISE_CITY,
  MERCHANDISE_POSTAL_CODE = AddressFormKey.MERCHANDISE_POSTAL_CODE,
  MERCHANDISE_STATE_CODE = AddressFormKey.MERCHANDISE_STATE_CODE,
  MERCHANDISE_IS_VALID = AddressFormKey.MERCHANDISE_IS_VALID,
}
